import { ntbActionType } from '../../actionTypes';

const initialState = {
  apiState: false,
  shouldShowOTPScreen: false,
  showOverlayScreen: false,
  showShowLenderList: false,
  showEligibilityModal: false,
  showNonApprovedModal: false,
  shouldShowServiceUnavailableModal: false,
  ntbDetails: {},
  message: '',
  redirectUrl: '',
  isNTBEnabledOnMerchant: false,
  userStatus: 'nonLoggedin',
};

const ntbConfig = (state = initialState, action) => {
  switch (action.type) {
    case ntbActionType.INIT_OTP_SCREEN:
      return {
        ...state,
        shouldShowOTPScreen: true,
        message: '',
      };

    case ntbActionType.SEND_OTP:
      return {
        message: '',
      };

    case ntbActionType.SEND_OTP_FAILURE:
      return {
        ...state,
        message: action.payload,
      };

    case ntbActionType.VERIFY_OTP:
      return {
        ...state,
        message: '',
      };

    case ntbActionType.VERIFY_OTP_FAILURE:
      return {
        ...state,
        shouldShowOTPScreen: true,
        message: action.payload,
      };

    case ntbActionType.LENDER_LIST_REQUEST:
      return {
        ...state,
        apiState: true,
      };

    case ntbActionType.CLOSE_ELIGIBILITY_MODAL:
      return {
        ...state,
        showEligibilityModal: false,
      };

    case ntbActionType.OPEN_ELIGIBILITY_MODAL:
      return {
        ...state,
        showEligibilityModal: true,
      };

    case ntbActionType.CLOSE_ELIGIBILITY_CHECK_MODAL:
      return {
        ...state,
        showNonApprovedModal: false,
      };

    case ntbActionType.OPEN_ELIGIBILITY_CHECK_MODAL:
      return {
        ...state,
        showNonApprovedModal: true,
      };

    case ntbActionType.INIT_LENDER_LIST_SCREEN:
      const { redirectUrl, isNTBEnabledOnMerchant, eligible } =
        action.payload || {};
      return {
        ...state,
        apiState: false,
        showShowLenderList: true,
        ntbDetails: action.payload,
        redirectUrl,
        isNTBEnabledOnMerchant,
        userStatus: eligible ? 'eligible' : 'notEligible',
      };

    case ntbActionType.CLOSE_OTP_OVERLAY_SCREEN:
      return {
        ...state,
        shouldShowOTPScreen: false,
      };

    case ntbActionType.OPEN_OVERLAY_SCREEN:
      return {
        ...state,
        showOverlayScreen: true,
      };

    case ntbActionType.CLOSE_OVERLAY_SCREEN:
      return {
        ...state,
        showOverlayScreen: false,
      };

    case ntbActionType.OPEN_SERVICE_UNAVAILABLE_MODAL:
      return {
        ...state,
        shouldShowOTPScreen: false,
        shouldShowServiceUnavailableModal: true,
        redirectUrl: action.payload.redirectUrl,
      };
    case ntbActionType.USER_STATUS:
      return {
        ...state,
        userStatus: action.payload.userStatus,
      };
    case ntbActionType.NTB_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default ntbConfig;



// WEBPACK FOOTER //
// ./reducer/ntbActivation/index.js